<template>
  <div id="message">
    <div class="title">总表实时信息</div>
    <div class="num_1">
        <p>{{allpress}}</p>
    </div>
    <div class="num_2">
        <p>{{flowrate}}</p>
    </div>
  </div>
</template>

<script>
//import axios from 'axios'
export default {
    data(){
        return{
           allpress:'',
           flowrate:''     
        }
    },
    mounted(){
        // 定时执行重新获取数据
        this.getdata();
        setInterval(()=>{
            this.getdata()
        },300000)    
    },
    methods:{
        // 获取数据
        getdata(){
            this.allpress = '';
            this.flowrate = '';
//          var params = new URLSearchParams();
//          params.append("deptId", "892");
//          params.append("checkCode", "3F55CAEAEAA1261CEFB7369CB6987DDB");
//          axios.post("/api/data/getSummaryTableRealTimeInfo", params)
//          .then((res) => {
//                 console.log(Number(res.data.data.resData[0].pma_value).toFixed(2),Number(res.data.data.resData[0].water_device_sjll).toFixed(1))
                this.allpress = 0.39;
                this.flowrate = 2.3;
//          })
//          .catch((error) => {
//              console.log(error);
//          });
        }
    }
}
</script>

<style scoped>
#message{
    height: 18.05vh;
    width: 100%;
    background: url('@/assets/pengshui_bg_1.png') no-repeat center center;
    background-size: 100% 100%;
    position: relative;

}
.title{
    color: #ffffff;
    text-align: start;
    height: 5vh;
    line-height: 5vh;
    margin-left: 1vw;
    font-size: 18px;
}
.num_1{
    position: absolute;
    color: #ffffff;
    width: 30%;
    /* border: 1px solid red; */
    top: 8vh;
    left: 2.4vw;
    color: #649cff;
    font-size: 16px;
    font-family: 'pm';
}
.num_2{
    width: 30%;
    position: absolute;
    color: #649cff;
    top: 8vh;
    right: 1.9vw;
    font-size: 16px;
    font-family: 'pm';
}
</style>